import { Modal, ModalBody } from "reactstrap";

const EvidenceModal = ({ isOpen, toggle, evidence }) => {
  return (
    <Modal
      isOpen={isOpen}
      toggle={toggle}
      style={{
        marginTop: "5vh",
        width: "70vw",
        maxWidth: "512px",
        position: "relative",
      }}
    >
      {/* Stylish Close button */}
      <button
        onClick={toggle}
        style={{
          position: "absolute",
          top: "8px",
          right: "8px",
          fontSize: "1.8rem",
          border: "none",
          background: "transparent",
          cursor: "pointer",
          zIndex: 1051,
          transition: "all 0.2s ease-in-out",
          borderRadius: "50%",
          width: "20px",
          height: "20px",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
        }}
        onMouseEnter={e => {
          e.currentTarget.style.background = "rgba(0, 0, 0, 0.1)";
          e.currentTarget.style.transform = "scale(1.15)";
          e.currentTarget.style.color = "#4556f1ff";
        }}
        onMouseLeave={e => {
          e.currentTarget.style.background = "transparent";
          e.currentTarget.style.transform = "scale(1)";
          e.currentTarget.style.color = "#000";
        }}
      >
        &times;
      </button>

      {/* Body with padding so image doesn't touch the button */}
      <ModalBody
        style={{
          paddingTop: "40px",
          paddingLeft: "10px",
          paddingRight: "10px",
          paddingBottom: "30px",
          display: "grid",
        }}
      >
        <img
          src={evidence}
          alt="Evidence"
          style={{
            maxHeight: "70vh",
            margin: "0 auto",
            borderRadius: "8px",
          }}
        />
      </ModalBody>
    </Modal>
  );
};

export default EvidenceModal;
